/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import Header from '@features/header';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { AppLayout } from '../../layout/AppLayout';
import { HydratedRouteInterface } from '../../types/routes';
import { DefaultHome } from './flavours/DefaultHome';

export const homeRouteEntry: HydratedRouteInterface = {
  id: 'home',
  label: 'Home',
  path: '/:marketplace(marketplace)?',
  exact: true,
  component: HomeRoute
}

export function HomeRoute() {
  const { params } = useRouteMatch<{ marketplace: string }>();

  if (!params.marketplace) {
    return (
      <Redirect to='/marketplace' />
    );
  }

  return (
    <AppLayout className={'homeOverflow'} Header={
      <Header className={'responsivePage'} />
    }>
      <DefaultHome />
    </AppLayout>
  )
}

